import { applianceType } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLP extends LegrandModule {
    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }
}
